<div class="container-fluid p-4">

    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="fw-bold mb-0">Dispatch Management</h4>
    </div>



    <div class="row g-2 align-items-center mb-4">

        <!-- SEARCH -->
        <div class="col-md-3 form-floating">
            <input type="text" class="form-control" placeholder="Search Invoice / Name / Phone" [(ngModel)]="searchText"
                (input)="applyFilters()">
            <label>Search Invoice / Name / Phone</label>
        </div>

        <!-- STATUS FILTER -->
        <div class="col-md-3 form-floating">
            <select class="form-control" [(ngModel)]="statusFilter" (change)="applyFilters()">
                <option value="ALL">All Status</option>
                <option *ngFor="let status of statusList" [value]="status">
                    {{ status }}
                </option>
            </select>
            <label for="">Select a Status</label>
        </div>

        <!-- SHIPPING FILTER -->
        <div class="col-md-3 form-floating">
            <select class="form-control" [(ngModel)]="shippingFilter" (change)="applyFilters()">
                <option value="ALL">All Partner</option>
                <option *ngFor="let partner of shippingPartnerList" [value]="partner">
                    {{ partner }}
                </option>
            </select>
            <label for="">Select Shipping Partner</label>
        </div>

        <!-- RESET -->
        <div class="col-md-2">
            <button class="btn btn-danger mt-2" (click)="resetFilters()">Clear Filters <img class="img-fluid"
                    alt="clear" src="assets/img/icons/clear-alt.png"></button>
        </div>

    </div>

    <!-- TABLE -->
    <div class="container-fluid">
        <div class="table-style table-responsive table-bordered">
            <table class="table table-head-fixed text-nowrap text-center text-sm">
                <thead class="table-dark">
                    <tr>
                        <th>S.No</th>
                        <th>Invoice No</th>
                        <th>Customer Name</th>
                        <th>Phone Number</th>
                        <th>Total Items</th>
                        <th>Status</th>
                        <th>View Item</th>
                        <th>Time Tracking</th>
                        <th>Tracking ID</th>
                        <th>Weight</th>
                        <th>Shipping Amount</th>
                        <th>Shipping Partner</th>
                        <th>Update Status</th>
                        <th>Print</th>
                    </tr>
                </thead>

                <tbody *ngIf="orders.length > 0">
                    <tr *ngFor="let order of orders; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ order?.invoiceNumber }}</td>
                        <td>{{ order?.customerName }}</td>
                        <td>{{ order?.phoneNumber }}</td>
                        <td>{{ order?.orderItems?.length }}</td>

                        <!-- STATUS -->
                        <td>
                            <span class="badge" [ngClass]="{
                    'bg-warning': order?.orderStatus === 'PLACED',
                    'bg-info': order?.orderStatus === 'PROCESSING',
                    'bg-primary': order?.orderStatus === 'PACKED',
                    'bg-success': order?.orderStatus === 'SHIPPED'
                  }">
                                {{ order?.orderStatus }}
                            </span>
                        </td>

                        <td>
                            <button class="btn btn-sm btn-light view-btn" (click)="openItemsModal(order)"
                                title="View Items">
                                <i class="bi bi-eye"></i>
                            </button>
                        </td>

                        <td>
                            <button class="btn btn-sm btn-info" title="View Time Tracking"
                                (click)="openTimeTrackingModal(order)">
                                <i class="bi bi-clock-history"></i>
                            </button>
                        </td>

                        <td>
                            <input type="text" class="form-control form-control-sm" placeholder="Enter Tracking ID"
                                [(ngModel)]="order.trackingNumber" [disabled]="!isOrderPacked(order)">
                        </td>
                        <td>
                            <input type="number" class="form-control form-control-sm" placeholder="Enter a Wight"
                                [(ngModel)]="order.weight" [disabled]="!isOrderPacked(order)" [min]="1">
                        </td>

                        <td>
                            <div class="input-group input-group-sm">

                                <span class="input-group-text">₹</span>

                                <input type="number" class="form-control" placeholder="Enter Shipping Amount"
                                    [(ngModel)]="order.shippingAmount" 
                                    [disabled]="!isOrderPacked(order)" min="0" step="0.01">

                            </div>
                        </td>

                        <td>
                            <select class="form-control" *ngIf="order?.orderType === 'COD'"
                                [value]="order?.orderType === 'COD' ? order?.shippingPartner : ''"
                                [(ngModel)]="order.shippingPartner" [disabled]="!isOrderPacked(order)">
                                <option value="">Select Partner</option>
                                <option value="ST COURIER">ST COURIER</option>
                                <option value="PROFESSIONAL">PROFESSIONAL</option>
                                <option value="INDIA POST">INDIA POST</option>
                                <option value="DTDC">DTDC</option>

                            </select>
                            <p *ngIf="order.orderType !== 'COD'">{{order?.shippingPartner || '-'}}</p>
                        </td>

                        <td>
                            <button class="btn btn-success btn-sm me-2" [disabled]="!isOrderPacked(order)"
                                (click)="updateShipping(order)">
                                Update Shipping
                            </button>
                        </td>

                        <td>
                            <button class="btn btn-warning btn-sm" (click)="printBill(order)">
                                Print Bill
                            </button>
                        </td>

                    </tr>
                </tbody>

                <tbody *ngIf="orders.length === 0">
                    <tr>
                        <td class="text-danger" colspan="13">No Orders Found</td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</div>

<!-- ================= MODAL ================= -->
<div class="custom-backdrop" *ngIf="isItemsModalOpen">

    <!-- ===== MODAL ===== -->
    <div class="custom-modal" (click)="$event.stopPropagation()">

        <div class="modal-header">
            <h5 class="modal-title">
                Order Items - {{ selectedOrder?.invoiceNumber }}
            </h5>

            <button class="btn-close" (click)="closeItemsModal()"></button>
        </div>

        <div class="modal-body">

            <table class="table table-bordered text-center">
                <thead class="table-light">
                    <tr>
                        <th>S.No</th>
                        <th>Product Image</th>
                        <th>Category</th>
                        <th>Sub Category</th>
                        <th>Product</th>
                        <th>Barcode Number</th>
                        <th>Size</th>
                        <th>Qty</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of orderItems;let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>
                            <div class="image-card d-flex justify-content-center align-items-center">

                                <img [src]="getImageById(item?.imageDetails?.imageDetailsId)"
                                    class="img-fluid rounded shadow-sm preview-img" alt="Product Image"
                                    (click)="openImage(item?.imageDetails?.imageDetailsId)" style="cursor: pointer;">
                            </div>
                        </td>
                        <td>{{ item?.productName }}</td>
                        <td>{{ item?.categoryName }}</td>
                        <td>{{ item?.subCategoryName}}</td>
                        <td>{{ item?.barcode }}</td>
                        <td>{{ item?.size }}</td>
                        <td>{{ item?.quantity }}</td>
                        <td>
                            <span class="badge" [ngClass]="{
                    'bg-warning': item?.orderStatus === 'PLACED',
                    'bg-info': item?.orderStatus === 'PROCESSING',
                    'bg-primary': item?.orderStatus === 'PACKED',
                    'bg-success': item?.orderStatus === 'SHIPPED'
                  }">
                                {{ item?.orderStatus }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <div class="modal-footer">

            <button *ngIf="selectedOrder?.orderStatus === 'PROCESSING'" class="btn btn-warning btn-sm me-1"
                (click)="updateFullOrderStatus('PLACED')">
                Reassign
            </button>

            <button class="btn btn-success btn-sm me-1" (click)="updateFullOrderStatus('PACKED')">
                Packed
            </button>

            <button class="btn btn-danger btn-sm me-1" (click)="closeItemsModal()">
                Close
            </button>

        </div>

    </div>
</div>

<!-- ================= TIME TRACKING MODAL ================= -->

<div class="custom-backdrop" *ngIf="isTimeTrackingModalOpen">

    <div class="custom-modal time-tracking-modal" (click)="$event.stopPropagation()">

        <!-- HEADER -->
        <div class="modal-header">

            <div>
                <h5 class="modal-title mb-1">
                    Order Time Tracking
                </h5>

                <small class="text-muted">
                    Invoice No:
                    <strong>
                        {{ selectedTrackingOrder?.invoiceNumber || '-' }}
                    </strong>
                </small>

                <span class="mx-2">|</span>

                <small class="text-muted">
                    Order ID:
                    <strong>
                        {{ selectedTrackingOrder?.orderId || '-' }}
                    </strong>
                </small>
            </div>

            <button type="button" class="btn-close" (click)="closeTimeTrackingModal()">
            </button>

        </div>

        <!-- BODY -->
        <div class="modal-body">

            <!-- LOADING -->
            <div *ngIf="isTimeTrackingLoading" class="text-center py-4">

                <div class="spinner-border text-primary" role="status">
                </div>

                <p class="mt-2 mb-0">
                    Loading time tracking...
                </p>

            </div>


            <!-- NO DATA -->
            <div *ngIf="!isTimeTrackingLoading && timeTrackingList.length === 0" class="text-center text-danger py-4">

                <i class="bi bi-clock-history fs-2"></i>

                <p class="mb-0 mt-2">
                    No time tracking history found.
                </p>

            </div>


            <!-- TRACKING TABLE -->
            <div class="table-responsive" *ngIf="!isTimeTrackingLoading && timeTrackingList.length > 0">

                <table class="table table-bordered table-hover text-center align-middle text-center">

                    <thead class="table-dark">

                        <tr>
                            <th>S.No</th>
                            <th>Status</th>
                            <th>Description</th>
                            <th>Date & Time</th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr *ngFor="let tracking of timeTrackingList; let i = index">

                            <td>
                                {{ i + 1 }}
                            </td>

                            <!-- STATUS -->
                            <td>

                                <span class="badge" [ngClass]="getTimeTrackingStatusClass(tracking.status)">

                                    {{ tracking.status }}

                                </span>

                            </td>

                            <!-- DESCRIPTION -->
                            <td>

                                {{ tracking.description || '-' }}

                            </td>

                            <!-- DATE -->
                            <td>

                                {{ tracking.timestamp | date : "dd-MM-yyyy / hh:mm:a" }}

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

        <!-- FOOTER -->
        <div class="modal-footer">

            <button type="button" class="btn btn-danger btn-sm" (click)="closeTimeTrackingModal()">

                Close

            </button>

        </div>

    </div>

</div>